import React, {Dispatch, SetStateAction, useEffect, useRef, useState} from "react";
import {Col, Modal, Row, Table} from "react-bootstrap";
import {IoMdClose} from "react-icons/io";
import Datatables, {getCheckedItems} from "../../component/Datatables";
import axios from "axios";
import {toast} from "react-toastify";
import messageCodeDic from "../../../util/messageCodeDic";
import BMCSelect from "../../../components/common/BMCSelect";
import {getLoginUser} from "../../../helper/SecurityHelper";
import { Container } from "react-bootstrap";
import BMCInput from "../../../components/common/BMCInput";
import SHSearch from "../../component/BMCSearch";

interface IProps {
    setModalIsOpen: Dispatch<SetStateAction<boolean>>;
    modalIsOpen: boolean;
    detailData?: any;
    blngSiteList: object[];
    setBlngSiteList: Dispatch<SetStateAction<object[]>>;
    isSingleCheck?:boolean
    siteNm?:string

}

const AttndSrchModal = (props: IProps) => {
    const [datatable, setDatatable] = useState<any>();
    const [dataList, setDataList] = useState<any[]>([]);
    const searchFormRef = useRef<any>();
    const [data, setData] = useState<any>()
    const user = getLoginUser();
    useEffect(() => {
        if(dataList.length > 0 && props.blngSiteList.length > 0) {
            console.log('blngSiteList: ', props.blngSiteList)
            let settingList = dataList;

            settingList.map((data) => {
                props.blngSiteList.map((blngData:any) => {
                    if(data.siteId == blngData.siteId){
                        data._checked = true;
                    }
                })
            })
            setDataList(settingList);
        }
    }, [dataList])


    function fn_closeModal() {
        props.setModalIsOpen(false);
    }

    const fn_search = (e?: any) => {
        e?.preventDefault()
        datatable?.draw()
    }
    const fn_select = () => {
        var checkedData = getCheckedItems(datatable)
        if (checkedData.length == 0) {
            toast.warn('현장1을 선택해 주십시오.');
            return;
        }
        props.setBlngSiteList(checkedData);
        props.setModalIsOpen(false);
    }

    const fn_setFormData = (e: any) => {
        setData({
            ...data,
            [e.target.name]: e.target.value
        })
    }
    return (
        <div>
            <Modal
                className="bmc-modal" size="xl"
                show={props.modalIsOpen}
                onShow={()=>fn_search()}
                onHide={fn_closeModal}

            >

                <Modal.Header>
                    <div className="d-flex justify-content-between align-items-center w-100 bmc-font-SD">
                        참석자 선택
                        <IoMdClose className='hover:cursor-pointer' onClick={fn_closeModal}/>
                    </div>
                </Modal.Header>
                <Modal.Body className="px-4">
                        <SHSearch datatable={datatable} formRef={searchFormRef} btnType={'p'}>
                            <Row>
                                <Col>
                                    <Table className="bmc-font-SP bmc-fs-b2 my-3">
                                        <tbody>
                                        <tr className="border-top align-middle">
                                            <th className="bmc-bg-th" style={{width:'6%'}}>업체</th>
                                            <td style={{width:'19%'}}>
                                                <BMCSelect initOptionGb={'none'} name={'blngCmpnySeq'} selParam={{siteId: user.blngSiteId}}
                                                          disabled={true} codeGb={'siteCmpny'}
                                                          onChange={fn_setFormData}
                                                          value={data?.cmpnySeq}></BMCSelect>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                        </SHSearch>

                    <div className={'ge-result'}>
                        <Datatables
                            dataUrl={'/admin/api/user/retrieveUserDataListWithView'}
                            parameterFormRef={searchFormRef}
                            columns={[
                                {data: "companyName", title: "업체", textAlign: 'left'},
                                {data: "userName", title: "이름", textAlign: 'left'},
                                {data: "chrgNm", title: "직책", textAlign: 'center'},
                            ]}
                            checked={true}
                            isSingleCheck={false}
                            index={true}
                            datas={dataList}
                            onLoad={(dt: any) => {
                                setDatatable(dt)
                            }}
                            onClick={(data) => {

                            }
                            }
                        />
                    </div>

                </Modal.Body>

                <Modal.Footer className="py-2">
                    <div className='flex justify-center w-100'>
                        <button
                            className='bmc-btn pill l white me-3'
                            onClick={fn_closeModal}>닫기
                        </button>
                        <button onClick={fn_select}
                                className='bmc-btn pill p'>선택

                        </button>
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default AttndSrchModal;
